<template>
    <div>
        <div class="layout" v-if="isLoggedIn">
            <sidebar></sidebar>
            <router-view class="page"></router-view>
        </div>
        <login-form v-else/>
    </div>
</template>
<script>
import LoginFrom from "../../components/LoginForm";

export default {
  components: {
    "login-form": LoginFrom
  },
  computed: {
    isLoggedIn() {
      return store.state.user;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>



// WEBPACK FOOTER //
// src/pages/admin/Layout.vue